import { Modal } from 'react-bootstrap';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDownUp } from 'react-bootstrap-icons';

import Button from '@designSystem/Button';
import { geoMatchAddress } from '@features/geomatch/geoMatchInterfaces';
import {
  ConfirmStyledHeader,
  ConfirmModalText,
  ConfirmAddressText,
  ConfirmArrowsIcon,
  ConfirmSeparator,
  ConfirmModalBody
} from './styles/ConfirmStyles';
import { IPEcolor, BANcolor } from './styles/common';
import { HouseDoorFill } from 'react-bootstrap-icons';

const ConfirmationModal: React.FC<{
  handleClose: CallableFunction;
  confirm: CallableFunction;
  IPEaddress: geoMatchAddress | undefined;
  BANaddress: geoMatchAddress | undefined;
}> = ({ handleClose, confirm, IPEaddress, BANaddress }) => {
  const { t } = useTranslation();

  function choicesConfirmed() {
    handleClose();
    confirm();
  }

  return (
    <Modal show={true} onClose={handleClose} centered>
      <ConfirmStyledHeader>
        <Modal.Title>
          {t('features.geomatch.confirmation', 'Confirm your fix mismatch request')}
        </Modal.Title>
      </ConfirmStyledHeader>
      <ConfirmModalBody>
        <ConfirmModalText>
          {t('features.geomatch.choice1', 'Your choices show that the address: ')}
        </ConfirmModalText>
        <ConfirmAddressText color={IPEcolor}>
          <span>
            {IPEaddress?.name}
            {IPEaddress?.batiment_immeuble && (
              <>
                <HouseDoorFill size="13" />
                <>{IPEaddress.batiment_immeuble}</>
              </>
            )}
          </span>
        </ConfirmAddressText>
        <ConfirmSeparator>
          <ConfirmArrowsIcon>
            <ArrowDownUp />
          </ConfirmArrowsIcon>
        </ConfirmSeparator>
        <ConfirmModalText>{t('features.geomatch.choice2', 'match the address: ')}</ConfirmModalText>
        <ConfirmAddressText color={BANcolor}>{BANaddress?.name}</ConfirmAddressText>
      </ConfirmModalBody>
      <Modal.Footer>
        <Button design="white" onClick={() => handleClose()}>
          {t('component.button.back', 'Back')}
        </Button>
        <Button design="plain" onClick={() => choicesConfirmed()}>
          {t('component.button.confirm', 'Confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
